import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */
import SearchNav from './searchNav';
import HeadLine from './headLine';
import Summary from './summary';
import Form from './form';
import Hot from './hot';
import CommentBox from './commentBox';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        surveyData: this.props.content.surveyData,
    };

    render() {
        const { content } = this.props;
        const { search, isLoginAuth } = content;
        const { surveyData } = this.state;

        console.log(surveyData);

        return (
            <div className={styles.content}>
                <div className={styles.main}>
                    <Hot />
                </div>
            </div>
        );
    }
}

export default Content;
